<template>
  <hic-dialog title="生命体征编辑" :visible="visible" @open="init" @close="$emit('update:visible', false)" width="80%">
    <b style="font-size: 16px">测量时间：</b>
    <el-date-picker size="small" v-model="execTime" type="datetime" placeholder="选择日期时间" style="width: 15%;" :picker-options="pickerOptions" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
    
    <br/>
    <el-container>
      <!-- <hic-table :entities="myEntities" :condition="condition" @selection-change="selectionChange" :loading="loading" @load="page" :no-merge-fields="['医嘱内容']" :cell-class-name="styleClass"> -->
        
        <el-table :data="options" height="35rem">
        <el-table-column align="left" label="床位" prop="bedNo" width="150" key="bedNo">
          <template #default="{ row }">
            <span class="sub-title">{{ row.bedNo }}</span>
          </template>
        </el-table-column>
        <el-table-column align="left" label="患者" prop="patientName" width="130" key="patientName">
          <template #default="{ row }">
            <span>{{ row.patientName }}</span>
          </template>
        </el-table-column>
        <el-table-column align="left" label="体温" prop="temperature" width="130" key="temperature">
          <template #default="{ row }">
            <el-input v-model="row.temperature" v-hic-select @keyup.enter.native="focusNext('temperature')" ref="temperature"><span slot="suffix" class="unitLoc">℃</span></el-input>
          </template>
        </el-table-column>
        <el-table-column align="left" label="脉搏" prop="pulse" width="130" key="pulse">
          <template #default="{ row }">
            <el-input v-model="row.pulse" v-hic-select @keyup.enter.native="focusNext('pulse')" ref="pulse"><span slot="suffix" class="unitLoc">次 / 分</span></el-input>            
          </template>
        </el-table-column>
        <el-table-column align="left" label="呼吸" prop="respiratory" width="130" key="respiratory">
          <template #default="{ row }">
            <el-input v-model="row.respiratory" v-hic-select @keyup.enter.native="focusNext('respiratory')" ref="respiratory"><span slot="suffix" class="unitLoc">次 / 分</span></el-input>
          </template>
        </el-table-column>
        <el-table-column align="left" label="血压" prop="bloodPressure" width="150" key="bloodPressure">
          <template #default="{ row }">
            <el-input v-model="row.bloodPressure" v-hic-select @keyup.enter.native="focusNext('bloodPressure')" ref="bloodPressure"><span slot="suffix" class="unitLoc">mmHg</span></el-input>
            
          </template>
        </el-table-column>
        <el-table-column align="left" label="血糖" prop="bloodGlucose" width="150" key="bloodGlucose">
          <template #default="{ row }">
            <el-input v-model="row.bloodGlucose" v-hic-select @keyup.enter.native="focusNext('bloodGlucose')" ref="bloodGlucose"><span slot="suffix" class="unitLoc">mmol / L</span></el-input>
            
          </template>
        </el-table-column>
        <el-table-column align="left" label="特殊原因" prop="reason" width="130" key="reason">
          <template #default="{ row }">
            <hic-dict-selector size="medium" v-model="row.reason" dict-type="VitalSignReason"></hic-dict-selector>
          </template>
        </el-table-column>
        <el-table-column align="left" label="备注" width="130" prop="memo" key="memo">
          <template #default="{ row }">
            <el-input v-model="row.memo" type="textarea"></el-input>
            
          </template>
        </el-table-column>
        <el-table-column align="left" label="时间" prop="" key="">
          <template #default="{ row }">
            <span style="color: red;">{{ row.execTime }}</span>
          </template>
        </el-table-column>
    </el-table>
    <!-- </hic-table> -->
      <!-- <el-aside width="20rem">
        <el-input v-model="keyword" placeholder="搜索患者" size="small" class="bottom-pad"></el-input>
        <el-menu :default-active="currId" @select="selected" style="height: 30rem">
          <el-menu-item v-for="item in options" :index="item.id + ''" :key="item.id">
            <span><b>{{ item.bedNo }}</b>：{{ item.patientName }}</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-main>
        <h3 class="center info">
          <span v-if="patient" class="center">
            <span>床位：{{ patient.bedNo }}</span>
            <span class="left-pad">姓名：{{ patient.patientName }}</span>
          </span>
          <span v-else class="danger"> 请选择患者！ </span>
        </h3>
        <el-form label-width="8rem" size="small">
          <el-form-item label="体温">
            <el-input v-model="value.temperature" v-hic-select @keyup.enter.native="focusNext('temperature')" ref="temperature"><span slot="suffix">℃</span></el-input>
          </el-form-item>
          <el-form-item label="脉搏">
            <el-input v-model="value.pulse" v-hic-select @keyup.enter.native="focusNext('pulse')" ref="pulse"><span slot="suffix">次 / 分</span></el-input>
          </el-form-item>
          <el-form-item label="呼吸">
            <el-input v-model="value.respiratory" v-hic-select @keyup.enter.native="focusNext('respiratory')" ref="respiratory"><span slot="suffix">次 / 分</span></el-input>
          </el-form-item>
          <el-form-item label="血压">
            <el-input v-model="value.bloodPressure" v-hic-select @keyup.enter.native="focusNext('bloodPressure')" ref="bloodPressure"><span slot="suffix">mmHg</span></el-input>
          </el-form-item>
          <el-form-item label="血糖">
            <el-input v-model="value.bloodGlucose" v-hic-select @keyup.enter.native="focusNext('bloodGlucose')" ref="bloodGlucose"><span slot="suffix">mmol / L</span></el-input>
          </el-form-item>
          <el-form-item label="特殊原因">
            <hic-dict-selector v-model="value.reason" dict-type="VitalSignReason"></hic-dict-selector>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="value.memo" type="textarea"></el-input>
          </el-form-item>
          <el-form-item label="时间">
            <el-date-picker v-model="value.execTime" type="datetime" placeholder="选择日期时间" style="width: 100%" :picker-options="$utils.Dt.picker(['今天', '昨天', '前天'], '<=')" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          </el-form-item>
        </el-form>
      </el-main> -->
    </el-container>

    <template #footer>
      <el-button type="info" @click="$emit('update:visible', false)">关 闭</el-button>
      <el-button type="primary" @click="getValue(0)" ref="saveButton">保 存</el-button>
    </template>
  </hic-dialog>
</template>
<script>
  import api from "./api";
  export default {
    props: {
      visible: Boolean,
      patients: Array,
    },
    data() {
      return {
        value: {
          // id: null,
          temperature: null,
          pulse: null,
          respiratory: null,
          bloodPressure: null,
          bloodGlucose: null,
          reason: null,
          memo: null,
          execTime: null,
          ipNo: null,
          hospitalizationId: null,
          deptCode: null,
          patientCode: null,
          patientName: null,
          bedNo: null,
        },
        currId: null,
        keyword: null,
        errorPaient:[],
        execTime:null
      };
    },
    computed: {
      options() {
        return this.patients.filter((x) => !this.keyword || x.patientName.includes(this.keyword));
      },
      patient() {
        return this.patients.find((x) => x.id == this.currId);
      },
      pickerOptions:function(){
        let self =this
        return {
          shortcuts: [{
            text: '7点',
            onClick(picker) {
              let selDate = self.$utils.Fmt.date(picker.date) + ' 07:00:00';              
              picker.$emit('pick',selDate);
            }
          }, {
            text: '11点',
            onClick(picker) {
              let selDate = self.$utils.Fmt.date(picker.date) + ' 11:00:00';              

              picker.$emit('pick', selDate);
            }
          }, {
            text: '17点',
            onClick(picker) {
              let selDate = self.$utils.Fmt.date(picker.date) + ' 17:00:00';              

              picker.$emit('pick', selDate);
            }
          }, {
            text: '20点',
            onClick(picker) {
              let selDate = self.$utils.Fmt.date(picker.date) + ' 20:00:00';              

              picker.$emit('pick', selDate);
            }
          }]
        }
      }
    },
    methods: {
      init() {
        this.value.temperature = this.value.pulse = this.value.respiratory = this.value.bloodPressure = this.value.bloodGlucose = this.value.reason = this.value.memo = null;
        this.execTime = this.$utils.Dt.now();
        this.$nextTick(() => {
          this.$refs.temperature.focus();
        });
      },
      selected(id) {
        this.currId = id;
        this.value.execTime = this.$utils.Dt.now();
        this.$refs.temperature.focus();
      },
      getValue(inx){
        if(inx >= this.options.length){
          return
        }
        console.log('inx===',inx)
        this.save(this.options[inx],inx)
      },
      save(patient,curInx) {
        let isEmpty = true;
        for (const prop of ["temperature", "pulse", "respiratory", "bloodPressure", "bloodGlucose", "reason"]) {
          if (!!patient[prop]) {
            isEmpty = false;
            break;
          }
        }
        if (isEmpty) {
          this.$set(this.options[curInx],'execTime',this.execTime)
          curInx++
          this.getValue(curInx)
          return
          // this.errorPaient.push(patient)
          // this.$message.warning("请填写体征或选择特殊原因！");
          // this.$refs.temperature.focus();
          // return
        }
        let saveValue = {}
        for(let key in this.value){
          saveValue[key] = patient[key] || null
        }
        saveValue.hospitalizationId = patient.id;
        if(!saveValue.execTime) saveValue.execTime = this.execTime

        // this.value.ipNo = this.patient.ipNo;
        
        // this.value.deptCode = this.patient.deptCode;
        // this.value.patientCode = this.patient.patientCode;
        // this.value.patientName = this.patient.patientName;
        // this.value.bedNo = this.patient.bedNo;
        // this.value.execTime = this.$utils.Dt.now();
        console.log('this.value====',this.value)
        
        api.VitalSigns.save(saveValue).then((res) => {
          this.$emit("saved", res);
          for(let key in this.value){
            if(key != 'ipNo'&& key != 'hospitalizationId' && key != 'deptCode' &&key != 'patientCode' &&key != 'patientName' &&key != 'bedNo') this.options[curInx][key] = null
          }
          
          curInx++
          this.getValue(curInx)
          // this.init();
        });
      },
      focusNext(refName) {
        const next = ["temperature", "pulse", "respiratory", "bloodPressure", "bloodGlucose"];
        const index = next.indexOf(refName);
        if (index < next.length - 1) {
          this.$refs[next[index + 1]].focus();
          return;
        }
        this.$refs["saveButton"].$el.focus();
      },
    },
  };
</script>
<style scoped>
  .unitLoc{
    position: relative;top: 8PX;
  }
</style>